import { objectToFormData } from 'helpers/utils';

export const create = async data => {
 console.log(data, 'datos que seran enviados al servidor');
 return await objectToFormData(data);
};
